import React from 'react'
import { isString } from 'lodash'

import { SetupBlockedBanner } from '@/views/Organizations/components/SetupBlockedBanner'
import { SHARED_DRIVE_ACCESS_GUIDE_URL } from '@/views/Organizations/components/GoogleDriveConnectionForm.helpers'

/**
 * Tells the customer Balto cannot read one of their Shared Drives yet, and who to ask to
 * share it.
 *
 * @param {string} props.serviceAccountEmail the Balto service account to add as a Viewer;
 *   undefined or null when it is not known
 */
export const SharedDriveAccessBanner = ({ serviceAccountEmail }) => (
  <SetupBlockedBanner
    data-testid="google-drive-access-banner"
    heading="Waiting for access to your Shared Drives"
    links={[
      { url: SHARED_DRIVE_ACCESS_GUIDE_URL, label: 'How to share your Shared Drives with Balto' },
    ]}
  >
    Balto can&apos;t read one or more of your Shared Drives yet. A Manager of each Shared Drive
    needs to add{' '}
    {isString(serviceAccountEmail) ? (
      <strong>{serviceAccountEmail}</strong>
    ) : (
      'the Balto service account'
    )}{' '}
    as a Viewer. If your Google Workspace blocks external members, your Google admin must allow it
    first. Syncing starts on its own after that.
  </SetupBlockedBanner>
)
